import { Clock, MapPin, MegaphoneSimple } from "@phosphor-icons/react";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";

const DAY_EN = {
    Senin: "Monday",
    Selasa: "Tuesday",
    Rabu: "Wednesday",
    Kamis: "Thursday",
    Jumat: "Friday",
    Sabtu: "Saturday",
    Minggu: "Sunday",
};

export default function Jadwal({ schedules }) {
    const { lang, t } = useLang();

    const groups = [];
    schedules.forEach((s) => {
        let g = groups.find((x) => x.name === s.group);
        if (!g) {
            g = { name: s.group, items: [], notes: [] };
            groups.push(g);
        }
        if (s.day && s.day !== "-") g.items.push(s);
        else if (s.note) g.notes.push(s.note);
    });

    const dayLabel = (d) => (lang === "en" ? DAY_EN[d] || d : d);

    return (
        <section id="jadwal" className="py-24 md:py-32 border-t border-racing-line bg-[#FBF9F5]" data-testid="jadwal-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="06" title={t.ch_jadwal_t} subtitle={t.ch_jadwal_s} />

                {groups.length === 0 ? (
                    <p className="text-racing-muted" data-testid="jadwal-empty">{t.jadwal_empty}</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-racing-line border border-racing-line">
                        {groups.map((g, gi) => (
                            <Reveal key={g.name} delay={gi * 0.08}>
                                <div data-testid={`jadwal-group-${gi}`} className="h-full bg-racing-surface p-8 md:p-10">
                                    <h3 className="font-display uppercase text-2xl md:text-3xl text-neutral-900 leading-tight">
                                        {g.name}
                                    </h3>
                                    <div className="mt-6 border-t border-racing-line">
                                        {g.items.map((s, i) => (
                                            <div key={s.id} className="flex flex-wrap items-baseline gap-x-6 gap-y-1 py-4 border-b border-racing-line" data-testid={`jadwal-row-${gi}-${i}`}>
                                                <span className="font-display uppercase text-xl md:text-2xl text-racing-red w-28 shrink-0">
                                                    {dayLabel(s.day)}
                                                </span>
                                                <span className="flex items-center gap-2 text-sm text-neutral-900">
                                                    <Clock size={16} weight="bold" className="text-[#FFB800]" />
                                                    {s.time} WITA
                                                </span>
                                                <span className="flex items-center gap-2 text-sm font-light text-racing-muted">
                                                    <MapPin size={16} weight="bold" className="text-[#FFB800]" />
                                                    {s.location}
                                                </span>
                                            </div>
                                        ))}
                                        {g.notes.map((n, i) => (
                                            <p key={i} className="flex items-start gap-3 py-4 border-b border-racing-line text-sm font-light text-racing-muted" data-testid={`jadwal-note-${gi}-${i}`}>
                                                <MegaphoneSimple size={18} weight="duotone" className="mt-0.5 shrink-0 text-racing-red" />
                                                {n}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
